{
    "RandomiseTitle": "Willekeurig wachtwoord",
    "PasswordStrength": "Wachtwoord sterkte:",
    "PasswordStrength_0": "Te kort",
    "PasswordStrength_1": "Erg zwak",
    "PasswordStrength_2": "Zwak",
    "PasswordStrength_3": "Gematigd",
    "PasswordStrength_4": "Krachtig",
    "PasswordStrength_5": "Heel sterk",
    "NAME": "PasswordTextInput",
    "PasswordRequirements_Title": "Wachtwoordvereisten:"
}